import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  cardContainer: {
    width: '100%',
    maxWidth: 254,
    padding: "22px 16px",
    display: 'flex',
    backgroundColor: theme.palette.secondary.main + "40",
    borderRadius: 4,
    border: `solid 2px ${theme.palette.primary.main}`,
    borderTopWidth: 4,

    // [theme.breakpoints.down('xs')]: {
    //   maxWidth: "unset",
    // },
  },

  maleBorder: {
    borderTopColor: '#5778EC'
  },
  femaleBorder: {
    borderTopColor: '#C878CA'
  },

  cardIcon: {
    width: 32,
    height: 32,

    '& path': {
      fill: theme.palette.primary.main,
    },
  },


  cardContainerButtonContainer: {
    // position: 'relative'
  },

  expandButton: {
    position: 'absolute',
    left: "25%",
    top: -65,
    display: "flex",
    gap: 4,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4,
    backgroundColor: theme.palette.secondary.main + "40",
    padding: 12,
    color: theme.palette.primary.main,
    cursor: 'pointer',


    "&:hover": {
      opacity: 0.8
    }
  },

  cardInfoContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    marginLeft: 16,


    '& span': {
      texTransform: 'uppercase',
      display: 'block',
      maxWidth: 160,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',

      [theme.breakpoints.down('xs')]: {
        maxWidth: "unset",
        textWrap: 'wrap'
      },

    },


    '& span:nth-child(1)': {
      color: theme.palette.primary.main,
      fontSize: 16,

    },
    '& span:nth-child(2)': {
      color: theme.palette.secondary.main,
      fontSize: 12,
    },

    '& span:nth-child(3)': {
      color: '#000',
      fontSize: 12,
    },
  },

}))
